'use strict';

/** @type {import('./floor')} */
module.exports = Math.floor;



//////////////////
// WEBPACK FOOTER
// ./~/_math-intrinsics@1.1.0@math-intrinsics/floor.js
// module id = n3Y8
// module chunks = 0